export default __webpack_public_path__ + "static/media/preset_turquoise_red.7b412abf.jpg";